import { useCallback, useSyncExternalStore } from 'react';

/**
 * DESKTOP chegarasi — butun ilova uchun bitta.
 *
 * Shu nuqtadan boshlab: yon panel chiziladi, header to'liq bo'ladi
 * (breadcrumb, til, mavzu, `Ctrl K`) va karta ichidagi jadval qoladi.
 * Undan pastda esa pastki qator, toza header va bloklar ishlaydi.
 *
 * Konstanta shu yerda turadi, chunki uchta joy bir xil javob berishi
 * SHART: header tugmalarni yashirsa-yu, «Menyu» sheet hali chizilmagan
 * bo'lsa, til almashtirgich ikki chegara orasida yo'qolib qolardi.
 */
export const DESKTOP_QUERY = '(min-width: 1024px)';

/**
 * CSS media so'rovini REAKTIV o'qish.
 *
 * Kerak bo'ladigan joy kam va aniq: tor ekranda filtrlar "Filtrlar"
 * popoveriga yig'iladi. Buni CSS bilan qilish uchun bir xil boshqaruvlarni
 * ikki marta chizish kerak bo'lardi — ikkita bir xil `id`, ikkita bir xil
 * yorliq va ekran o'qigich uchun ikkilangan forma.
 *
 * `useSyncExternalStore` — chunki bu tashqi (brauzer) holati: React uni
 * o'zi bilmaydi va `useEffect` bilan o'qilsa birinchi kadr noto'g'ri
 * kenglikda chizilardi.
 */
export const useMediaQuery = (query: string): boolean => {
  const subscribe = useCallback(
    (onChange: () => void) => {
      if (typeof window.matchMedia !== 'function') return () => {};
      const list = window.matchMedia(query);
      list.addEventListener('change', onChange);
      return () => list.removeEventListener('change', onChange);
    },
    [query],
  );

  const read = useCallback(() => {
    // `matchMedia` bo'lmasa (eski test muhiti) KENG ekran deb hisoblaymiz:
    // yig'ilgan holat — istisno, yoyilgani esa odatiy ko'rinish.
    if (typeof window.matchMedia !== 'function') return true;
    return window.matchMedia(query).matches;
  }, [query]);

  return useSyncExternalStore(subscribe, read, () => true);
};
